"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bregnano": {
    "5dafc343": [{
      "hkey": "a83435fd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-giorgio": [{
      "hkey": "a83435fd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bregnano"
    }],
    "fb82d23c": [{
      "hkey": "a83435fd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "a83435fd",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bregnano"
    }]
  }
};
exports["default"] = _default;